"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let Job = class Job extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resource;
    async $$load_resource() {
        return this.$fn.fetch('read_a_job', { parameters: { id: this.oid }, asResource: true });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_5962862420439144_style;
    dataMembers = ['resource', 'ux', 'b_7315092382398562_modalBindings', 'b_5962862420439144_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resource: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
                b_5962862420439144_style: {
                    minHeight: "200px",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.$fn.pgettext("Job|Title", "Job"),
                    this.resource.name,
                    this.resource.id,
                ],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7690_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_8564662037462133_reload(event, scope) {
        return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_reloadSlickgrid_7698_getActionArgs($event) {
        return {
            grid: "jobs",
        };
    }
    async evh_8564662037462133_deleted(event, scope) {
        return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
    }
    async evh_1040167445267876_reload(event, scope) {
        return await this.actions.evh_1040167445267876_reload.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7690 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7690_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7689 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7690,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7689],
        });
        const act_2248226175642056_closeComponent_7692 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_7691 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_7692,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_7691],
        });
        const act_8564662037462133_reloadComponentData_7694 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8564662037462133_reload_7693 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadComponentData_7694,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8564662037462133_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_reload_7693],
        });
        const act_8564662037462133_closeModal_7696 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_8564662037462133_deleted_7695 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_closeModal_7696,
            event: "deleted",
            displayName: "closeModal",
        });
        const act_8564662037462133_reloadSlickgrid_7698 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8564662037462133_reloadSlickgrid_7698_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_deleted_7697 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadSlickgrid_7698,
            event: "deleted",
            displayName: "reloadSlickgrid",
        });
        const evh_8564662037462133_deleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_deleted_7695, evh_8564662037462133_deleted_7697],
        });
        const act_1040167445267876_reloadComponentData_7700 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_1040167445267876_reload_7699 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadComponentData_7700,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_1040167445267876_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_reload_7699],
        });
        const act_1548630417156826_closeComponent_7702 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_7701 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_7702,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_7701],
        });
        return {
            act_7315092382398562_closeModal_7690,
            evh_7315092382398562_close_7689,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_7692,
            evh_2248226175642056_close_7691,
            evh_2248226175642056_close,
            act_8564662037462133_reloadComponentData_7694,
            evh_8564662037462133_reload_7693,
            evh_8564662037462133_reload,
            act_8564662037462133_closeModal_7696,
            evh_8564662037462133_deleted_7695,
            act_8564662037462133_reloadSlickgrid_7698,
            evh_8564662037462133_deleted_7697,
            evh_8564662037462133_deleted,
            act_1040167445267876_reloadComponentData_7700,
            evh_1040167445267876_reload_7699,
            evh_1040167445267876_reload,
            act_1548630417156826_closeComponent_7702,
            evh_1548630417156826_clickPreventStop_7701,
            evh_1548630417156826_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], Job.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Job.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], Job.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Job.prototype, "onSize", null);
Job = __decorate([
    (0, vue_property_decorator_1.Component)()
], Job);
exports.default = Job;
vue_property_decorator_1.Vue.component("Job", Job);
